import * as angular from 'angular';

import { ComponentDefinition, DigitalSet } from '../../../../models';

class DigitalStatesTableController implements angular.IComponentController {
    formController: angular.IFormController;
    onRemoveState: ({ state: DigitalState }) => void;
    selectedSet: DigitalSet;

    readonly isEditMode: boolean;

    static $inject = [];

    onCodeChange($index: number) {
        const code = this.selectedSet.stateCollection[$index].code;
        const hasDuplicate = this.selectedSet.stateCollection.filter(s => s.code === code).length > 1;
        this.formController['code_' + $index].$setValidity('duplicate', !hasDuplicate);
    }

    removeState(state) {
        if (this.onRemoveState) {
            this.onRemoveState({ state });
        }
    }
}

export const wtDigitalStatesTable: ComponentDefinition = {
    componentId: 'wtDigitalStatesTable',
    controller: DigitalStatesTableController,
    template: require('./digitalStatesTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '<',
        isEditMode: '<',
        onRemoveState: '&?',
        selectedSet: '<'
    }
};
